import {
    GET_USER_ASSIGNED_APPLICATIONS,
    GET_USER_ASSIGNED_APPLICATIONS_FULFILLED,
    GET_USER_ASSIGNED_APPLICATIONS_REJECTED,

    GET_COMPLETE_USER_DETAILS,
    GET_COMPLETE_USER_DETAILS_REJECTED,
    GET_COMPLETE_USER_DETAILS_FULFILLED
} from '../constants/Action'


const initialState = {
    apps: [],
    details: {},
    profileName: "",
    loadingApps: false,
    errorApps: null,
    loading: false,
    error: null
}

export default (state = initialState, action)=>{
    switch(action.type){
        case GET_USER_ASSIGNED_APPLICATIONS:
            return {
                ...state,
                loadingApps: true,
                errorApps: null
            }
        
        case GET_USER_ASSIGNED_APPLICATIONS_FULFILLED:
            return {
                ...state,
                loadingApps: false,
                apps: action.payload.applicationdetailsList,
                errorApps: null,
            }
        
        case GET_USER_ASSIGNED_APPLICATIONS_REJECTED:
            return {
                ...state,
                loadingApps: false,
                errorApps: action.payload,
            }

        case GET_COMPLETE_USER_DETAILS:
            return {
                ...state,
                details: {},
                loading: true,
                error: null
            }
        
        case GET_COMPLETE_USER_DETAILS_FULFILLED:
            return {
                ...state,
                loading: false,
                details: action.payload,
                profileName: action.payload.firstname + " " + action.payload.lastname,
                error: null,
            }
        case GET_COMPLETE_USER_DETAILS_REJECTED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                profileName: ""
            }
    }
    return state
} 
